import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormInput } from 'shared/components'

const TeamFiltersComponent = ({ form }) => (
  <Form form={form}>
    <FormInput name="search" icon="search" placeholder="Search..." />
  </Form>
)

TeamFiltersComponent.propTypes = {
  form: PropTypes.shape().isRequired,
}

export default TeamFiltersComponent
